<template>
  <main>
    <div
      class="koc-view koc-navbar-view"
      data-observe-resize
    >
      <div class="koc-navbar-view-container">
        <div class="koc-navbar-view-container-flex-row">
          <ul class="koc-navbar-view-container-main-list">
            <li
              v-for="item in items"
              :key="item.ID"
              class="koc-navbar-view-container-main-list-item"
            >
              <a
                :href="item.url"
                class="koc-title-3"
                :class="item.custom_class"
                :target="item.target"
              >{{ item.title }}</a>
            </li>
          </ul>
          <div
            v-if="accountUrl"
            class="koc-navbar-view-container-login-container"
          >
            <span
              v-if="state.user"
              class="koc-navbar-view-user-icon-wrapper"
              @mouseover="mouseOverAccountMenu"
              @mouseleave="mouseLeaveAccountMenu"
            >
              <a>
                <font-awesome-icon
                  :icon="['fa', 'user']"
                  class="koc-navbar-view-user-icon"
                />
              </a>
              <div
                :class="state.showAccountLinks ? 'open' : ''"
                class="koc-navbar-view-container-account-container"
              >
                <span class="koc-navbar-view-container-account-container-greeting">Hello {{ state.user.displayName }},</span>
                <a
                  :href="accountUrl"
                  class="koc-navbar-view-container-account-container-link"
                >Account Page</a>
                <a
                  class="koc-navbar-view-container-account-container-link"
                  @click.stop="logoutMethod"
                >Logout</a>
              </div>

            </span>
            <a
              v-else
              class="koc-title-3 koc-navbar-view-login-link"
              @click.stop="showLoginOverlay"
            >
              Login
            </a>
          </div>
          <div
            v-show="!state.showMobileMenu"
            class="koc-navbar-view-container-hamburger-menu-container"
            @click="state.showMobileMenu = !state.showMobileMenu"
          >
            <span class="top" />
            <span class="middle-top" />
            <span class="middle-bottom" />
            <span class="bottom" />
          </div>
        </div>
      </div>
      <div
        v-if="state.showMobileMenu"
        class="koc-navbar-view-mobile-menu-overlay koc-notification koc-fixed koc-full koc-view"
      >
        <div class="koc-navbar-view-mobile-menu-content">
          <div class="koc-navbar-view-mobile-menu-close-container">
            <a @click.stop="state.showMobileMenu = false;">
              <font-awesome-icon
                :icon="['fa', 'xmark']"
                size="2x"
                class="koc-navbar-view-mobile-menu-close-icon"
              />
            </a>
          </div>
          <div class="koc-navbar-view-mobile-menu-container">
            <ul class="koc-navbar-view-mobile-menu-list">
              <li
                v-for="item in items"
                :key="item.ID"
                class="koc-navbar-view-mobile-menu-list-item"
              >
                <a
                  :href="item.url"
                  :target="item.target"
                  class="koc-title-3"
                >{{ item.title }}</a>
              </li>
              <li
                v-if="accountUrl"
                key="account"
                class="koc-navbar-view-mobile-menu-list-item"
              >
                <a
                  :href="accountUrl"
                  class="koc-title-3"
                >Account Page</a>
              </li>
              <li
                v-if="accountUrl && !state.hasUser"
                key="login"
                class="koc-navbar-view-mobile-menu-list-item"
              >
                <a
                  class="koc-title-3"
                  @click.stop="showLoginOverlay"
                >Login</a>
              </li>
              <li
                v-else-if="accountUrl && state.hasUser"
                key="logout"
                class="koc-navbar-view-mobile-menu-list-item"
              >
                <a
                  class="koc-title-3"
                  @click.stop="logoutMethod"
                >Logout</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>


    <div
      v-if="state.showOverlay"
      class="koc-notification koc-fixed koc-dark koc-full koc-view koc-dark-theme"
    >
      <div class="koc-login-overlay-form-container">
        <div
          v-show="!event"
          class="koc-navbar-view-mobile-menu-close-container"
        >
          <a @click.stop="state.showOverlay = false;">
            <font-awesome-icon
              :icon="['fa', 'xmark']"
              size="2x"
              class="koc-close"
            />
          </a>
        </div>
        <div class="koc-kol-logo-container">
          <img
            v-if="logoUrl"
            :src="logoUrl"
          >
          <img
            v-else
            src="@/assets/images/kol-logo-white.png"
          >
        </div>
        <h3
          class="koc-auth-login-notification-text"
          v-html="state.notification"
        />
        <auth-login-component
          v-if="state.showLogin"
          @login="login"
        />
      </div>
    </div>
  </main>
</template>

<script src="./navbar.js"></script>
<style lang="scss" scoped src="./navbar.scss"></style>
